import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Workbox } from 'workbox-window';
import App from './App.vue';

// Import UnoCSS virtual module
import 'virtual:uno.css';

// Import global styles
import './styles/main.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.mount('#app');

// Log application startup
console.log('Safetrax WebConfig v1.0.0');
console.log('WebSerial API available:', 'serial' in navigator);

if (!('serial' in navigator)) {
  console.warn('⚠️  WebSerial API not supported in this browser. Please use Chrome or Edge.');
}

// Register service worker for offline support
if ('serviceWorker' in navigator) {
  const wb = new Workbox('/sw.js');

  // When a new SW has installed and is waiting to activate, skip waiting
  // and reload so users always get the latest version automatically.
  wb.addEventListener('waiting', () => {
    wb.messageSkipWaiting();
  });

  wb.addEventListener('controlling', () => {
    window.location.reload();
  });

  wb.register().catch((err) => {
    console.warn('Service worker registration failed:', err);
  });
}
